export const colors = {
  // Style Guide Colors
  primaryColor: '#207bcc',
  primaryHighlight: '#ecf5fe',
  primaryAccent: '#596097',
  secondaryColor: '#fd6120',
  secondaryAccent: '#de4f18',
  darkAccent: '#3c3d3f',
  highlightBright: '#edeef0',
  highlightMedium: '#b8c5d0',
  highlightDark: '#9da4ad',
  highlightDarker: '#3c4c65',
  successGreen: '#4eda1f',
  errorRed: '#dc3636',
  white: '#ffffff',
};

export const formButton = {
  margin: '5px',
};
